import { _firestore } from '../../firebase';
import {
  getCurrentFormattedMomentDate,
  getCurrentTimestamp,
} from '../../helpers/timeHelper';
import { selectStoreConfig } from '../Layout/selectors';

import ActionTypes from './constants';

export function updatePendingOrder(order, status) {
  return (dispatch, getState) => {
    const storeConfig = selectStoreConfig(getState());
    let requestObj = {
      orderId: order._id,
      orderStatus: status,
      date: getCurrentFormattedMomentDate(
        storeConfig.timeZone,
        'YYYY-MM-DD HH:mm'
      ),
      dateTimestamp: getCurrentTimestamp(),
    };
    fetch(`${storeConfig.cloudFunctionsUrl}/confirmOrder`, {
      method: 'post',
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...requestObj,
      }),
    })
      .then((res) => res.json())
      .then((_result) => {
        dispatch(orderUpdated(true));
      });
  };
}

export function fetchPendingOrder(orderId) {
  return (dispatch) => {
    try {
      let ref = _firestore.collection('Orders').doc(orderId);

      ref.onSnapshot((doc) => {
        let obj = { _id: doc.id, ...doc.data() };
        dispatch(pendingOrderfetched(obj));
      });
    } catch (e) {
      console.error(e);
    }
  };
}

export function getHalfHalf(storeId) {
  return (dispatch) => {
    _firestore
      .collection('ProductSetup')
      .where('storeId', '==', storeId)
      .onSnapshot((querySnapshot) => {
        var dataArray = [];
        querySnapshot.forEach((doc) => {
          dataArray.push({ _id: doc.id, ...doc.data() });
        });
        dispatch(
          halfFetched(
            dataArray.length > 0
              ? dataArray[0]
              : { halfHalfs: [], halfHalfAdditionalCharges: 0 }
          )
        );
      });
  };
}

function pendingOrderfetched(pendingOrder) {
  return {
    type: ActionTypes.FetchOrder,
    pendingOrder,
  };
}

function orderUpdated(isOrderUpdated) {
  return {
    type: ActionTypes.OrderUpdated,
    isOrderUpdated,
  };
}

function halfFetched(halfHalfSetup) {
  return {
    type: ActionTypes.FetchHalfHalf,
    halfHalfSetup,
  };
}
